module.exports = "<fa-icon  [attr.aria-label]=\"helpText\" [matTooltip]=\"helpText\" [icon]=\"faQuestionCircle\">\r\n</fa-icon>"